import { render, staticRenderFns } from "./AssignSecondaryProcess.vue?vue&type=template&id=4d3eebf8&"
import script from "./AssignSecondaryProcess.vue?vue&type=script&lang=js&"
export * from "./AssignSecondaryProcess.vue?vue&type=script&lang=js&"
import style0 from "./AssignSecondaryProcess.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports